// components/Accordion.tsx

import React, { ReactNode, useState } from "react";
import * as Styled from "./Accordion.styled";
interface AccordionProps {
  title: ReactNode | string;
  children: ReactNode;
}
const Accordion: React.FC<AccordionProps> = ({
  title,
  children
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <Styled.AccordionSection data-sentry-element="unknown" data-sentry-component="Accordion" data-sentry-source-file="index.tsx">
            <Styled.AccordionTitle onClick={() => setIsOpen(!isOpen)} data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                {title}
                <Styled.AccordionIcon data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    {isOpen ? "▲" : "▼"}
                </Styled.AccordionIcon>
            </Styled.AccordionTitle>
            {isOpen && <Styled.AccordionContent>{children}</Styled.AccordionContent>}
        </Styled.AccordionSection>;
};
export default Accordion;